import { render, staticRenderFns } from "./EmailFormalizacaoView.vue?vue&type=template&id=2fe9cf02&scoped=true"
import script from "./EmailFormalizacaoView.vue?vue&type=script&lang=js"
export * from "./EmailFormalizacaoView.vue?vue&type=script&lang=js"
import style0 from "./EmailFormalizacaoView.vue?vue&type=style&index=0&id=2fe9cf02&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe9cf02",
  null
  
)

export default component.exports